<script>
import {
  Link,
  NavTitle,
  Popup,
  Navbar,
  Page,
  Popover,
  List,
  ListInput,
  ListItem,
  Block,
  Checkbox,
  Row,
  Col,
  Button,
  PhotoBrowser,
  NavRight
} from 'framework7-svelte';
import InfoSistema from './InfoSistema.svelte'
import Alertas from './infoSistema/Alertas.svelte'
import Campo from './infoSistema/Campo.svelte'
import Contacto from './infoSistema/Contacto.svelte'
import InfoDisponible from './infoSistema/InfoDisponible.svelte'
import VisitasGuiadas from './infoSistema/VisitasGuiadas.svelte'
import ImgCarto from './infoSistema/ImgCarto.svelte'
import FormaCitar from './infoSistema/FormaCitar.svelte'
import Responsable from './infoSistema/Responsable.svelte'
import AcercaSatif from './infoSistema/AcercaSatif.svelte'
import Agradecimientos from './infoSistema/Agradecimientos.svelte'
import ProximasImagenes from './infoSistema/ProximasImagenes.svelte'
import { getPredictedOverpasses } from "../../tools/service/dates";

  $: responsive=(innerWidth<=960) ? false : true;
  let innerWidth;
  let standaloneDark;
  let promise_predicted = getPredictedOverpasses({ name: "today" });

    const handleClick = () => {
      promise_predicted = getPredictedOverpasses({ name: "today" });
    }
    
</script>

<style>

</style>

<svelte:window bind:innerWidth={innerWidth}/>

  {#if !responsive}
  <List>
    <Navbar title="SATIF"/>
    <ListItem link="#" popupOpen=".popover-menu" title="Avisos" />
    <ListItem link="#" popupOpen=".demo-popup-contacto" title="Contacto" />
    <ListItem link="#" popupOpen=".demo-popup-acerca" title="Información del sistema" />
  </List>
  {:else}
    <Link popoverOpen=".popover-menu"><NavTitle sliding>Avisos</NavTitle></Link>
    <Link popupOpen=".demo-popup-contacto"><NavTitle sliding>Contacto</NavTitle></Link>
    <Link popoverOpen=".demo-popup-acerca"><NavTitle sliding>Información del sistema</NavTitle></Link>
  {/if}

<!-- sección Avisos-->
<Popover class="popover-menu" themeDark>
  <List>
    <ListItem link="#" popoverClose popupOpen=".demo-popup-alerta" title="Alertas por correo" />
    <ListItem link="#" popoverClose popupOpen=".demo-popup-icampo" title="Información de campo" />
    <ListItem link="#" popoverClose onClick={() => standaloneDark.open()} title="Próximas imágenes" />
    <!-- <ListItem link="#" popoverClose popupOpen=".demo-popup-pimagenes" title="Próximas imágenes" /> -->
  </List>
</Popover>
<Popup class="demo-popup-alerta" themeDark backdrop swipeToClose>
  <Page>
    <Navbar title="Registro de notificaciones por correo">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <Alertas></Alertas>
  </Page>
</Popup>
<Popup class="demo-popup-icampo" themeDark swipeToClose>
  <Page>
    <Navbar title="Información de campo">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <Campo></Campo>
  </Page>
</Popup>
<Popup class="demo-popup-pimagenes" tabletFullscreen themeDark swipeToClose>
  <Page>
    <Navbar title="Próximas imágenes">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <ProximasImagenes></ProximasImagenes>
  </Page>
</Popup>
<p>
  {#await promise_predicted}
      <p>.</p>
  {:then data}
          <PhotoBrowser photos={data} navbarOfText="de" theme="dark" bind:this={standaloneDark} />
  {:catch error}
      <p>Oh no: {error}</p>
  {/await}
  
</p>

<Popup class="demo-popup-preguntas" themeDark swipeToClose>
  <Page>
    <Navbar title="Preguntas frecuentes">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <div style="height: 100%" class="display-flex justify-content-center align-items-center">
      </div>
  </Page>
</Popup>
<!-- sección Contacto-->
<Popup class="demo-popup-contacto" themeDark backdrop swipeToClose>
  <Page>
    <Navbar title="Retroalimentación de usuarios">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <Contacto></Contacto>
  </Page>
</Popup>
<!-- sección Información del sistema-->
<Popover class="demo-popup-acerca" themeDark>
  <List>
    <ListItem link="#" popoverClose popupOpen=".demo-popup-satif" title="Acerca de SATIF" />
    <ListItem link="#" popoverClose popupOpen=".demo-popup-guiadas" title="Visitas guiadas" />
    <ListItem link="#" popoverClose popupOpen=".demo-popup-disponible" title="Información disponible" />
    <ListItem link="#" popoverClose popupOpen=".demo-popup-imgcarto" title="Imágenes y cartografía utilizada" />
    <ListItem link="#" popoverClose popupOpen=".demo-popup-responsable" title="Responsables" />
    <ListItem link="#" popoverClose popupOpen=".demo-popup-citar" title="Forma de citar" />
    <ListItem link="#" popoverClose popupOpen=".demo-popup-agradecimientos" title="Agradecimientos" />
  </List>
</Popover>
<Popup class="demo-popup-satif" tabletFullscreen themeDark swipeToClose>
  <Page>
    <Navbar title="Acerca de SATIF">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <AcercaSatif></AcercaSatif>
  </Page>
</Popup>
<Popup class="demo-popup-guiadas" themeDark backdrop swipeToClose>
  <Page>
    <Navbar title="Visitas guiadas">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <VisitasGuiadas></VisitasGuiadas>
  </Page>
</Popup>
<Popup class="demo-popup-disponible" tabletFullscreen themeDark swipeToClose>
  <Page>
    <Navbar title="Información disponible">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <InfoDisponible></InfoDisponible>
  </Page>
</Popup>
<Popup class="demo-popup-imgcarto" tabletFullscreen themeDark swipeToClose>
  <Page>
    <Navbar title="Imágenes y cartografía utilizada">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <ImgCarto></ImgCarto>
  </Page>
</Popup>
<Popup class="demo-popup-responsable" themeDark backdrop swipeToClose>
  <Page>
    <Navbar title="Responsables">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <Block>
      <Responsable></Responsable>
    </Block>
  </Page>
</Popup>
<Popup class="demo-popup-citar" themeDark backdrop swipeToClose>
  <Page>
    <Navbar title="Forma de citar">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <Block>
      <FormaCitar></FormaCitar>
    </Block>
  </Page>
</Popup>
<Popup class="demo-popup-agradecimientos" themeDark backdrop swipeToClose>
  <Page>
    <Navbar title="Agradecimientos">
      <NavRight>
        <Link popupClose panelClose>Close</Link>
      </NavRight>
    </Navbar>
    <Block>
      <Agradecimientos></Agradecimientos>
    </Block>
  </Page>
</Popup>
<!--<Popup class="demo-popup-acerca" themeDark tabletFullscreen swipeToClose animate={false}>
  <Page>
    <Navbar title="Sistema de Alerta Temprana de Incendios Forestales (SATIF)">
      <NavRight>
        <Link popupClose panelClose>Cerrar</Link>
      </NavRight>
    </Navbar>
    <InfoSistema></InfoSistema>
  </Page>
</Popup>-->

